import { render, staticRenderFns } from "./Cliente.vue?vue&type=template&id=a8c74648&scoped=true&"
import script from "./Cliente.vue?vue&type=script&lang=js&"
export * from "./Cliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c74648",
  null
  
)

export default component.exports